export const stickyHeader = () => {
	let scrollpos = window.scrollY;

	let header = document.querySelector(".main-header");
	let scrollChange = 100;

	if (header) {

		let add_class_on_scroll = () => header.classList.add("sticky");
		let remove_class_on_scroll = () => header.classList.remove("sticky");

		window.addEventListener('scroll', function() {
			scrollpos = window.scrollY;

			if (scrollpos >= scrollChange) { add_class_on_scroll() }
			else { remove_class_on_scroll() }

		})

		if(window.location.hash) {
			var hash = window.location.hash.substring(1);
			var button = document.querySelector("."+hash);
			if(button){
				button.length > 1 ? button[0].click() : button.click();
			}
		}

	}
}
